// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stripePublishableKey: "pk_test_51SxXS6EEUmzlhS15r0jY8wPCVgBEL3pU3HnTRfYLqkKojhB4SHbIzzdheqH6epuVeJXHMnQlqF7Q4s2ef9i2G7Af00159XqkwL",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
